// extracted by mini-css-extract-plugin
export default {"opaqueMask":"NonEditableMask_opaqueMask__qthJq","returnLabel":"NonEditableMask_returnLabel__dILiq"};